<script lang="ts">
  // libs
  import Authorization from "@shared/svelte/Components/Authorization.svelte";

  // stores
  import layoutStore from "@shared/svelte/Stores/LayoutStore";

  // types
  import type { CartType } from "@shared/types/Cart";

  // props
  export let managers;
  export let managersForSubmit;
  export let cart: CartType;
  export let containerClasses: string = "";

  // data
  managers.forEach(m => {
    managersForSubmit[m.id] = true;
  });

</script>

<Authorization authName={"carts.submit_approval"}>
  {#if !cart.submitted_for_approval_at}
    <div class:fizz-inset-squish-16={$layoutStore.isMobile}>
      <div class={containerClasses} data-testid="manager-approvals-new">
        <div class="fizz-stack-16">
          <h5 class="fizz-heading-5">Select managers to review this order</h5>
          <p class="fizz-text-small fizz-stack-12">
            Your order will be sent to selected managers for review
          </p>
        </div>
        <ul class="fizz-flow-8 fizz-stack-12">
          {#each managers as manager}
            <li>
              <label class="fizz-flex-row-8">
                <input
                  type="checkbox"
                  class="fizz-checkbox"
                  bind:checked={managersForSubmit[manager.id]}
                />
                <span>{manager.first_name} {manager.last_name}</span>
              </label>
            </li>
          {/each}
        </ul>
      </div>
    </div>
  {/if}
</Authorization>
